import React from "react";
import { useNavigationGuard } from "../../../context/navigation-guard-provider";

interface GuardedLinkProps {
    to: string;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const GuardedLink = ({ to, children, className, style }: GuardedLinkProps) => {
    const { requestNavigation } = useNavigationGuard();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        requestNavigation(to);
    };

    return (
        <a
            href={to}
            onClick={handleClick}
            className={className}
            style={style}
        >
            {children}
        </a>
    );
};

export default GuardedLink;